var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.announcements.length
      ? _c(
          "div",
          { staticClass: "table-responsive" },
          [
            _c("table", { staticClass: "table table-striped" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pages.admin.livestream.announcements.model.title"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pages.admin.livestream.announcements.model.starts_at"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$t("actions.actions")))])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.announcements, function(announcement) {
                  return _c("tr", [
                    _c("td", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(announcement.title[_vm.$i18n.locale]) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm
                              .$date(announcement.starts_at)
                              .format("DD.MM.YYYY HH:mm")
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "btn btn-sm btn-outline-warning",
                            attrs: {
                              tag: "button",
                              to: {
                                name: "admin.livestream.announcement.edit",
                                params: { announcement: announcement.id }
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "mdi mdi-pencil" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("actions.edit")) +
                                "\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-outline-danger",
                            on: {
                              click: function($event) {
                                _vm.selectedToDelete = announcement
                              }
                            }
                          },
                          [_c("i", { staticClass: "mdi mdi-trash-can" })]
                        )
                      ],
                      1
                    )
                  ])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("announcement-delete-modal", {
              attrs: { selected: _vm.selectedToDelete },
              on: {
                "announcement-deleted": function($event) {
                  return _vm.$emit("reload")
                }
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.announcements.length && _vm.emptyText !== null
      ? _c("div", { staticClass: "alert alert-secondary border-dark" }, [
          _vm._v("\n        " + _vm._s(_vm.emptyText) + "\n    ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }